// extracted by mini-css-extract-plugin
export var actionIcon = "_o7-0";